import React from 'react';
import { testimonials } from '../data/mock';
import { Star, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  return (
    <section id="testimonials" className="py-16 md:py-24 bg-white" aria-label="Dog Boarding Baltimore Reviews">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block bg-amber-100 text-amber-700 font-semibold text-sm px-4 py-1.5 rounded-full mb-4">
            Reviews & Testimonials
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-4">
            What Baltimore Dog Owners Say About Us
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what your Baltimore neighbors are saying about our <strong>dog boarding services</strong>.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-stone-50 rounded-2xl p-6 md:p-8 border border-stone-100 hover:border-amber-200 hover:shadow-lg transition-all duration-300 relative"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center">
                <Quote className="w-5 h-5 text-amber-600" />
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-amber-500 fill-amber-500" />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-stone-700 leading-relaxed mb-6 text-lg">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-lg">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-semibold text-stone-800">{testimonial.name}</p>
                  <p className="text-sm text-stone-500">
                    {testimonial.location} • Dog: {testimonial.dogName}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
